import Box from '@mui/material/Box';
import { alpha, type Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { formatDelta } from './data/format.js';

export type MetricSentiment = 'good' | 'bad' | 'neutral';

interface MetricDeltaProps {
  delta: number | null;
  sentiment: MetricSentiment;
  suffix?: string;
}

function sentimentColor(theme: Theme, sentiment: MetricSentiment): string | null {
  if (sentiment === 'good') return theme.palette.success.dark;
  if (sentiment === 'bad') return theme.palette.error.dark;
  return null;
}

export function MetricDelta({ delta, sentiment, suffix }: MetricDeltaProps): ReactNode {
  if (delta === null) return null;

  return (
    <Box
      component="span"
      sx={(theme) => {
        const tone = sentimentColor(theme, sentiment);
        return {
          display: 'inline-flex',
          fontSize: 10,
          fontWeight: 700,
          borderRadius: `${theme.radius.pill}px`,
          py: 0,
          px: 1,
          whiteSpace: 'nowrap',
          ...(tone === null
            ? { color: theme.palette.text.secondary }
            : { color: tone, bgcolor: alpha(tone, 0.14) }),
        };
      }}
    >
      {suffix === undefined ? formatDelta(delta) : `${formatDelta(delta)} ${suffix}`}
    </Box>
  );
}
